const Graph = require('./BaseGraph')

module.exports = class TrackerGraph extends Graph 
{
    constructor(apiDomain, path="learnearn")
    {
        super(apiDomain, path)
    }

    setArticlePoints(fields, params=null)
    {
        if (params)
            return { type: 'createPoint', query: `mutation {
                createPoint(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'createPoint', query: `mutation createPoint ($content_id: Int!, $contact_id: String!, $earned_point: Int!) {
            createPoint(content_id: $content_id, contact_id: $contact_id, earned_point: $earned_point, content_type: $content_type)
            ${this.queryFields(fields)}
        }` }
    }


    setVideoPoints(fields, params=null)
    {
        if (params)
            return { type: 'createPoint', query: `mutation {
                createPoint(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'createPoint', query: `mutation createPoint ($content_id: Int!, $contact_id: String!, $earned_point: Int!, $time_watched: String) {
            createPoint(content_id: $content_id, contact_id: $contact_id, earned_point: $earned_point, time_watched: $time_watched)
            ${this.queryFields(fields)}
        }` }
    }
    
    updateVideoStatus(fields, params=null)
    {
        if (params)
            return { type: 'updatePoint', query: `mutation {
                updatePoint(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'updatePoint', query: `mutation updatePoint ($content_id: Int!, $contact_id: String!) {
            updatePoint(content_id: $content_id, contact_id: $contact_id)
            ${this.queryFields(fields)}
        }` }
    }


    setUserBadge(fields, params=null)
    {
        if (params)
            return { type: 'addBadge', query: `mutation {
                addBadge(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'addBadge', query: `mutation addBadge ($contact_id: String!) {
            addBadge(contact_id: $contact_id)
            ${this.queryFields(fields)}
        }` }
    }

    getUserBadgeQuery(fields, params=null)
    {
        if (params)
            return { type: 'userBadges', query: this.queryString('userBadges', fields, params) }

        return { type: 'userBadges', query: `query userBadges ($contact_id: String!) {
            userBadges($contact_id: $contact_id)
            ${this.queryFields(fields)}
        }` }
    }
}